export default '/seriehistorica'
